import './index.css';
import { View, Text, Image } from '../../../component';
import useTheme from '../../../utilities/hooks/theme';
import React from 'react';
import { isSmartPhone } from '../../../utilities/helper';

interface Props {
  contestCategory: any;
  totalChallenges: any;
}

const AllContestListHeader = ({ totalChallenges = 0, contestCategory = {} }: Props) => {
  const { FantasyTheme: theme } = useTheme();
  const { title = '', imageUrl = '', id = '' } = contestCategory;

  const mainLabel = {
    color: theme.contestListItemHeaderTitle
  };

  const subLabel = {
    color: theme.contestListItemHeaderSubTitle
  };
  return (
    <View
      key={id}
      className={
        isSmartPhone
          ? 'all-contest-list-header-container__mWeb'
          : 'all-contest-list-header-container'
      }>
      <View
        style={{
          width: '40px',
          height: '40px'
        }}>
        <Image
          source={imageUrl}
          placeHolderType={'ContestCategory'}
          style={{
            width: '100%',
            height: '100%'
          }}
        />
      </View>
      <View className={'all-contest-list-header-label-content'}>
        <Text className={'all-contest-list-header-main-label'} style={mainLabel}>
          {title}
        </Text>
        <Text
          className={'all-contest-list-header-desc-label'}
          style={subLabel}>{`${totalChallenges} Contest Available`}</Text>
      </View>
    </View>
  );
};
export default React.memo(AllContestListHeader);
